import { FC, memo } from 'react';

import { IconBase, IconBaseProps } from './IconBase';

export const IconStarFilled: FC<IconBaseProps> = memo(props => {
  return (
    <IconBase {...props} viewBox="0 0 32 33">
      <path
        d="M15.5245 1.96352C15.6741 1.50287 16.3259 1.50287 16.4755 1.96353L19.48 11.2102C19.5469 11.4162 19.7389 11.5557 19.9555 11.5557H29.6781C30.1624 11.5557 30.3638 12.1755 29.972 12.4602L22.1062 18.175C21.931 18.3023 21.8577 18.528 21.9246 18.734L24.929 27.9807C25.0787 28.4414 24.5515 28.8245 24.1596 28.5398L16.2939 22.825C16.1186 22.6977 15.8814 22.6977 15.7061 22.825L7.84038 28.5398C7.44853 28.8245 6.92129 28.4414 7.07096 27.9807L10.0754 18.734C10.1423 18.528 10.069 18.3023 9.89377 18.175L2.02804 12.4602C1.63619 12.1755 1.83758 11.5557 2.32194 11.5557H12.0445C12.2611 11.5557 12.4531 11.4162 12.52 11.2102L15.5245 1.96352Z"
        fill="currentColor"
      />
    </IconBase>
  );
});
